(() => {
  const initialize = (scope = document) => scope.querySelectorAll('[data-pb-product]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-pb-config]').textContent);
    const controller = new AbortController();
    root.pbCleanup = () => { controller.abort(); observer.disconnect(); };
    const on = (element, event, fn) => element?.addEventListener(event, fn, {signal: controller.signal});
    let price = Number(root.dataset.price), quantity = 1, active = 0;
    let images = [...root.querySelectorAll('[data-photo]')].map(b => b.dataset.photo);
    const main = root.querySelector('[data-main-image]');
    const lightbox = root.querySelector('.pb-lightbox');
    const currency = root.dataset.currency || 'TRY';
    const money = value => new Intl.NumberFormat('tr-TR', {style:'currency',currency}).format(value / 100);
    const packTotal = count => Math.max(0, price * count - (count >= 3 ? 25000 : count >= 2 ? 12500 : 0));
    const updatePrice = () => {
      root.querySelectorAll('[data-total]').forEach(e => e.textContent = money(packTotal(Number(e.dataset.total))));
      root.querySelectorAll('[data-current-total]').forEach(e => e.textContent = money(packTotal(quantity)));
    };
    const showImage = index => {
      active = (index + images.length) % images.length;
      main.src = images[active];
      root.querySelectorAll('[data-photo]').forEach((b, i) => b.setAttribute('aria-pressed', String(i === active)));
      lightbox.querySelector('img').src = images[active];
      root.querySelector('.pb-photo-label').hidden = active === 2 || active === 3;
    };
    on(root.querySelector('.pb-thumbs'), 'click', event => {
      const b = event.target.closest('[data-photo]');
      if (b) showImage(images.indexOf(b.dataset.photo));
    });
    on(root.querySelector('.pb-gallery-next'), 'click', () => showImage(active + 1));
    on(root.querySelector('.pb-zoom'), 'click', () => { lightbox.querySelector('img').src = main.src; lightbox.showModal(); });
    root.querySelectorAll('[data-guide-zoom]').forEach(b => on(b, 'click', () => { lightbox.querySelector('img').src=images[Number(b.dataset.guideZoom)]; lightbox.querySelector('img').alt=b.getAttribute('aria-label'); lightbox.showModal(); }));
    on(root.querySelector('[data-close-lightbox]'), 'click', () => lightbox.close());
    on(lightbox, 'click', e => {if (e.target === lightbox) lightbox.close();});
    root.querySelectorAll('input[name=quantity]').forEach(r => on(r, 'change', () => { quantity = Number(r.value); updatePrice(); }));
    root.querySelectorAll('[data-color-select]').forEach(button => on(button, 'click', () => {
      if (!config.preview) return;
      const item = config[button.dataset.colorSelect];
      root.dataset.color = button.dataset.colorSelect;
      root.querySelectorAll('[data-color-select]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
      root.querySelector('[data-title]').textContent = item.title;
      root.querySelectorAll('[data-color-name]').forEach(e => e.textContent = item.color);
      root.querySelectorAll('[data-measure]').forEach(e => e.textContent = item.measure);
      main.alt = item.title; lightbox.querySelector('img').alt = item.title;
      price = item.price; images = item.images;
      const thumbs = root.querySelector('.pb-thumbs');
      thumbs.replaceChildren(...images.map((src, i) => {
        const b = document.createElement('button'); b.type='button';b.dataset.photo=src;b.setAttribute('aria-label', `${i+1}. görseli göster`);
        const img=document.createElement('img');img.src=src;img.width=90;img.height=90;img.loading='lazy';img.alt=`${item.color} plise perde — görünüm ${i+1}`;b.append(img);return b;
      }));
      root.querySelectorAll('[data-story-photo]').forEach(e => {e.src = images[Number(e.dataset.storyPhoto)] || images[0];});
      root.querySelectorAll('[data-marketing-image]').forEach(e => { e.src=images[Number(e.dataset.marketingImage)]; e.alt=item.color+' plise perde — '+(Number(e.dataset.marketingImage)===2?'Ölçü alma rehberi':'Kurulum kontrolü'); });
      showImage(0);updatePrice();
    }));
    const variant = root.querySelector('[data-variant]');
    if (variant) {
      const selectedId=variant.value;
      const options=[...variant.options].sort((a,b)=>{
        const [aw,ah]=a.dataset.measure.match(/\d+/g).map(Number),[bw,bh]=b.dataset.measure.match(/\d+/g).map(Number);
        return ah-bh || aw-bw;
      });
      options.forEach(option=>option.textContent=`${option.dataset.measure} — ${money(Number(option.dataset.price))}${option.dataset.available==='true'?'':' — Stokta yok'}`);
      variant.replaceChildren(...options);variant.value=selectedId;
      const sizes=options.map(option=>({option,dimensions:option.dataset.measure.match(/\d+/g).map(Number)}));
      if(sizes.every(size=>size.dimensions.length===2)) {
        const picker=document.createElement('div');picker.className='pb-dimension-picker';
        const groups=[{index:1,label:'1. Boy seçin',name:'boy'},{index:0,label:'2. En seçin',name:'en'}];
        const summary=document.createElement('p');summary.className='pb-selected-size';summary.setAttribute('role','status');summary.setAttribute('aria-live','polite');
        const sync=()=>{
          const selected=sizes.find(size=>size.option.value===variant.value);
          picker.querySelectorAll('[data-dimension]').forEach(button=>{
            const index=Number(button.dataset.dimension),value=Number(button.dataset.value);
            const match=sizes.find(size=>size.dimensions[index]===value&&size.dimensions[1-index]===selected.dimensions[1-index]);
            button.setAttribute('aria-pressed',String(selected.dimensions[index]===value));
            button.disabled=!match;
          });
          summary.textContent=`Seçiminiz: ${selected.dimensions[0]} × ${selected.dimensions[1]} cm · ${money(Number(selected.option.dataset.price))} / adet`;
        };
        groups.forEach(group=>{
          const fieldset=document.createElement('fieldset');fieldset.className='pb-dimension-group pb-dimension-'+group.name;
          const legend=document.createElement('legend');legend.textContent=group.label+' (cm)';fieldset.append(legend);
          const grid=document.createElement('div');grid.className='pb-dimension-options';
          [...new Set(sizes.map(size=>size.dimensions[group.index]))].sort((a,b)=>a-b).forEach(value=>{
            const button=document.createElement('button');button.type='button';button.textContent=value+' cm';button.dataset.dimension=group.index;button.dataset.value=value;
            button.setAttribute('aria-label',`${group.name==='boy'?'Boy':'En'} ${value} cm`);
            on(button,'click',()=>{
              const selected=sizes.find(size=>size.option.value===variant.value);
              const match=sizes.find(size=>size.dimensions[group.index]===value&&size.dimensions[1-group.index]===selected.dimensions[1-group.index]);
              if(match){variant.value=match.option.value;variant.dispatchEvent(new Event('change',{bubbles:true}));}
            });grid.append(button);
          });fieldset.append(grid);picker.append(fieldset);
        });
        picker.append(summary);variant.after(picker);variant.hidden=true;
        root.querySelector(`label[for="${variant.id}"]`).hidden=true;
        on(variant,'change',sync);sync();
      }
      on(variant, 'change', () => {
        const option=variant.selectedOptions[0];price=Number(option.dataset.price);config.available=option.dataset.available==='true';
        const button=root.querySelector('[data-atc]');button.disabled=!config.available;
        root.querySelector('[data-atc-label]').textContent=config.available?'SEPETE EKLE':'STOKTA YOK';
        root.querySelector('[data-form-status]').textContent=config.available?'':'Bu ürün şu anda satışa açık değil.';
        root.querySelectorAll('[data-measure]').forEach(e => e.textContent=option.dataset.measure);
        const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);
        const custom=root.querySelector('[data-custom-size]');
        if(custom) {
          const text=`Merhaba, özel ölçü plise perde için fiyat ve uygunluk bilgisi almak istiyorum. Ürün: ${root.querySelector('[data-title]').textContent}. İncelediğim standart ölçü: ${option.dataset.measure}. İstediğim en: … cm, boy: … cm, adet: … . ${url.href}`;
          custom.href=`https://wa.me/${custom.dataset.phone}?text=${encodeURIComponent(text)}`;
        }
        updatePrice();
      });
    }
    on(root.querySelector('[data-cart-form]'), 'submit', async e => {
      e.preventDefault();if(!config.available || config.preview) return;
      const button=root.querySelector('[data-atc]'),status=root.querySelector('[data-form-status]');
      const previousLabel=root.querySelector('[data-atc-label]').textContent;
      button.disabled=true;button.setAttribute('aria-busy','true');root.querySelector('[data-atc-label]').textContent='EKLENİYOR';status.textContent='';
      try {
        const response=await fetch(e.target.action+'.js',{method:'POST',body:new FormData(e.target),headers:{Accept:'application/json'}});
        const data=await response.json();if(!response.ok) throw new Error(data.description||'Ürün eklenemedi. Lütfen tekrar deneyin.');
        const link=document.createElement('a');link.href=(window.Shopify?.routes?.root || '/')+'cart';link.textContent='Ürün sepete eklendi. Sepeti görüntüle →';status.replaceChildren(link);
      } catch(error){status.textContent=error.message;} finally {button.disabled=!config.available;button.removeAttribute('aria-busy');root.querySelector('[data-atc-label]').textContent=previousLabel;}
    });
    const sticky=root.querySelector('[data-sticky]');
    const observer=new IntersectionObserver(entries => {const entry=entries[0];sticky.hidden=entry.isIntersecting || entry.boundingClientRect.top>0;},{threshold:0});
    observer.observe(root.querySelector('[data-cart-form]'));
    updatePrice();
  });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',e=>initialize(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-pb-product]').forEach(r=>r.pbCleanup?.()));
})();
